import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useFormats } from '../../toolympus/components/schemed';
import moment, { MomentInput } from 'moment';
import { ThemeSettings } from '../../theme';

interface Props {
  value: string | null | undefined;
  noRedZone?: boolean;
}

export const getDeadlineLevel = (d: MomentInput) => {
  if(!d) {
    return "ok";
  }
  const mv = moment(d);
  const daysDiff = mv.diff(moment(), 'days');
  if(daysDiff < 0) {
    return "danger";
  } else if (daysDiff < 7) {
    return "warning";
  }

  return "ok";
}

export const DeadlineNote = (props: Props) => {
  const { value } = props;


  const [daysDiff, weeksDiff] = useMemo(() => {
    if (!value) return [null, null];
    const mv = moment(value);
    return [mv.diff(moment(), 'days'), Math.floor(mv.diff(moment(), 'days') / 7)];
  }, [value]);

  if (daysDiff === null || weeksDiff === null)
    return null;

  if (daysDiff < 0) {
    return (
      <Note alert={props.noRedZone ? undefined : "danger"}>
        {daysDiff}d
      </Note>
    );
  } else if (daysDiff < 7) {
    return (
      <Note alert={props.noRedZone ? undefined : "warning"}>
        {daysDiff}d
      </Note>
    );
  } else if (daysDiff < 14) {
    return <Note>{daysDiff}d</Note>;
  } else {
    return <Note>{weeksDiff}w</Note>;
  }
}

export const DeadlineDisplay = (props: Props) => {
  const { formatDate } = useFormats();
  const { value } = props;

  return (
    <Typography>
      {value ? formatDate(value) : "-"}
      <DeadlineNote {...props} />
    </Typography>
  );
}

const Note = styled.span<{ alert?: "warning" | "danger"}>`
  margin-left: 0.5rem;
  color: ${props => props.alert === "danger" ? ThemeSettings.colors.danger : props.alert === "warning" ? ThemeSettings.colors.warning : ThemeSettings.colors.success};
  font-size: ${ThemeSettings.fontSize.small};
`;

